<template>
    <div class="navbar">
        <router-link to="/"><img alt="onestep logo" src="../assets/common/logo_onestep.png"/></router-link>
        <el-menu
            :default-active="this.$router.path"
            router
            mode="horizontal"
            active-text-color="#11A9FB"
            text-color = "#fff"
            menu-trigger ="hover">
            <el-submenu index="1" route="/company">
                <template slot="title">COMPANY</template>
                <el-menu-item @click="goTopView('aboutUs')">About Us</el-menu-item>
                <el-menu-item @click="goTopView('solutionMatrix')">Solution Matrix</el-menu-item>
                <el-menu-item @click="goTopView('contactUs')">Contact</el-menu-item>
            </el-submenu>
            <el-submenu index="2">
                <template slot="title">PRODUCTS</template>
                <el-menu-item index="/carConfigurator">Car Configurator</el-menu-item>
                <el-menu-item index="/mobileSmartCar">Mobile Smart Car Sales Assistance</el-menu-item>
                <el-menu-item index="/realTime3d">Realtime 3D Asset Visualization</el-menu-item>
                <el-menu-item index="/autoDrive">Auto Drive Content Platform</el-menu-item>
                <el-menu-item index="/VR&AR">VR & AR Innovation</el-menu-item>
            </el-submenu>
            <el-menu-item index="3" :route="{path:'/projects'}">PROJECT</el-menu-item>
            <el-menu-item index="4" @click="goBrandNav">CUSTOMERS & PARTNERS</el-menu-item>
        </el-menu>
    </div>
</template>
<script>

export default {
  data () {
    return {
    }
  },
  methods: {
    goBrandNav () {
        this.$nextTick(() => {
            this.$router.push('/?#brandExperience')
        })
    },
    goTopView(selector){
        this.$nextTick(() => {
            this.$router.push('/company?#'+selector)
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../style/common'
.navbar
    width 100%
    height 5rem
    background rgba(0,0,0,.8)
    position fixed
    z-index 9999
    flex()
    img
        width 14rem
        cursor pointer
        margin-left 1rem
/deep/ .el-menu
    height 5rem
    background none!important
    margin 0 1rem 0 0
/deep/ .el-menu.el-menu--horizontal
    border none
/deep/ .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover
    background rgba(0,0,0,.5)
/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title
    height 5rem
    line-height 5rem
    font-size 1rem
    border-bottom none
    padding:0 2rem
/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title:hover
    background rgba(0,0,0,.4)
    border-bottom none
    color #11A9FB!important
/deep/ .el-menu--horizontal>.el-submenu i 
    color #fff
    font-size .9rem
/deep/ .el-menu--horizontal>.el-submenu:hover i
    color #11A9FB!important
/deep/ .el-menu--horizontal>.el-menu-item
    height 5rem
    line-height 5rem
    font-size 1rem
    border-bottom none
    background none
/deep/ .el-menu--horizontal>.el-menu-item.is-active
    border-bottom none
    color #11A9FB!important 
/deep/ .el-menu--horizontal>.el-submenu.is-active
    color #11A9FB!important
    border none
    border-bottom none
/deep/ .el-submenu__title
    border-bottom none!important
</style>
<style lang="stylus">
.el-menu--horizontal
    .el-menu
        background rgba(0,0,0,.8)
        .el-menu-item
            background none!important
            font-size .9rem
            text-align center
            font-weight 400
        .el-menu-item:hover
            color #11A9FB!important
.el-menu--horizontal>.el-menu-item:hover
    color #11A9FB!important
</style>
